var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisacardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 20,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3324_12370)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 834,
    height: 1113,
    transform: "translate(-384 -363)",
    fill: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-217 -15C-217 -17.7614 -214.761 -20 -212 -20H278C280.761 -20 283 -17.7614 283 -15V36C283 38.7614 280.761 41 278 41H-212C-214.761 41 -217 38.7614 -217 36V-15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27.9655,
    height: 19,
    rx: 3.5,
    fill: "white",
    stroke: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8605 13.7166H10.9321L12.1383 6.71626H14.0666L12.8605 13.7166Z",
    fill: "#15195A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8513 6.8874C19.4709 6.74576 18.8676 6.58937 18.1216 6.58937C16.2172 6.58937 14.8762 7.54256 14.868 8.90534C14.8521 9.91079 15.8281 10.4692 16.5581 10.8045C17.3042 11.1471 17.5578 11.3707 17.5578 11.676C17.5502 12.145 16.9549 12.3612 16.3997 12.3612C15.6298 12.3612 15.2172 12.2497 14.5903 11.9888L14.3364 11.877L14.0665 13.4484C14.5188 13.6418 15.3521 13.8134 16.2172 13.8209C18.2407 13.8209 19.558 12.8825 19.5736 11.4302C19.5813 10.6334 19.066 10.0227 17.9549 9.52377C17.2804 9.20347 16.8674 8.98749 16.8674 8.65976C16.8753 8.36183 17.2167 8.05667 17.9781 8.05667C18.605 8.04172 19.0657 8.18317 19.4146 8.32471L19.589 8.39905L19.8513 6.8874Z",
    fill: "#15195A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3032 6.71626H24.7948L26.3506 13.7165H24.565C24.565 13.7165 24.3903 12.9122 24.3349 12.6664H21.859C21.7873 12.8525 21.4542 13.7165 21.4542 13.7165H19.4308L22.2952 7.29709C22.4937 6.84276 22.8432 6.71626 23.3032 6.71626ZM23.1843 9.278C23.1843 9.278 22.5732 10.8345 22.4144 11.2366H24.0173C23.938 10.8866 23.5728 9.21099 23.5728 9.21099L23.438 8.6078C23.3813 8.76312 23.2992 8.97666 23.2438 9.1207C23.2063 9.21834 23.1811 9.28404 23.1843 9.278Z",
    fill: "#15195A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.57639 6.71626H5.67907C6.09962 6.73101 6.44088 6.85761 6.55192 7.30471L7.22622 10.5211C7.22628 10.5213 7.22634 10.5215 7.22641 10.5217L7.43278 11.4898L9.32137 6.71626H11.3605L8.32935 13.7092H6.29008L4.57125 7.6265C3.97821 7.30107 3.30138 7.03934 2.54465 6.85771L2.57639 6.71626Z",
    fill: "#15195A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3324_12370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 834,
    height: 1113,
    fill: "white",
    transform: "translate(-384 -363)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisacardicon);
export default __webpack_public_path__ + "static/media/visacardicon.16b32a7e2bf6b54188fe4f22e9852bb8.svg";
export { ForwardRef as ReactComponent };